import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=3853d3ca&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3853d3ca')) {
      api.createRecord('3853d3ca', component.options)
    } else {
      api.reload('3853d3ca', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=3853d3ca&", function () {
      api.rerender('3853d3ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2U2N4Db8m2KFn/JS/comp/ErrorMessage.vue"
export default component.exports